import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var NavigationArrow = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M15.554 30.248a1 1 0 01-1-1V17.694H3a1 1 0 01-.462-1.887L28.785 2.113a1 1 0 011.35 1.35L16.44 29.71a.998.998 0 01-.886.537zM7.079 15.694h8.475a1 1 0 011 1v8.476L26.89 5.358z" })), '0 0 32 32', 'NavigationArrow');
//# sourceMappingURL=NavigationArrow.js.map